import { canAccessClientStorageWrapper } from "./embed";

type SessionStorageKey =
  | "isShareFormPopupClosed"
  | "isConnectBankPopupClosed"
  | "donorWelcomeAlertDismissed"
  | "activationCardDismissMobileStorageDate";

// Commented out because it's not used anywhere
// Uncomment if needed
// export const removeFromSessionStorage = canAccessClientStorageWrapper(
//   () => (key: string) => window.sessionStorage.removeItem(key)
// );

export const getFromSessionStorage = canAccessClientStorageWrapper(
  () => (key: SessionStorageKey) => window.sessionStorage.getItem(key) || undefined
);

export const setInSessionStorage = canAccessClientStorageWrapper(
  () => (key: SessionStorageKey, value: string) => window.sessionStorage.setItem(key, value)
);
